/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTiposPenalidades() {
        return axiosJwt.get(`${api}/tipospenalidades`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterRecursos() {
        return axiosJwt.get(`${api}/recursos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluir(penalidade) {
        return axiosJwt.delete(`${api}/contratos/${penalidade.contratoId}/penalidades/${penalidade.penalidadeId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(penalidade) {
        return axiosJwt.post(`${api}/contratos/${penalidade.contratoId}/penalidades`, penalidade)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(penalidade) {
        return axiosJwt.put(`${api}/contratos/${penalidade.contratoId}/penalidades`, penalidade)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPenalidade(contratoId, penalidadeId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/penalidades/${penalidadeId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPenalidades(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/penalidades`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    exportar(contratoId) {
        let url = `${api}/contratos/${contratoId}/penalidades/exportar`
        return axiosJwt.get(url, {
            responseType: 'blob'
        }).then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },
}
